<template>
      <div class="product-card p-2">
        <div class="product-card-top">
            <div class="product-image"></div>
        </div>

        <div class="product-card-info">
            <div class="product-price mb-1"></div>
            <div class="product-name mb-1"></div>
            <div class="d-flex align-items-center justify-content-between mb-1">
                <div class="product-rating"></div>
                <div class="product-sold"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>
